import React from 'react';
import { useTable } from 'react-table';

const TopFiveWorkingEffiency = () => {
    const data = React.useMemo(
        () => [
            {
                shift1: 1, shift2: 2, shift3: 3, shift4: 4, shift5: 5, shift6: 6,
            },
            {
                shift1: 1, shift2: 2, shift3: 3, shift4: 4, shift5: 5, shift6: 6,
            },
            {
                shift1: 1, shift2: 2, shift3: 3, shift4: 4, shift5: 5, shift6: 6,
            },
            {
                shift1: 1, shift2: 2, shift3: 3, shift4: 4, shift5: 5, shift6: 6,
            },
            {
                shift1: 1, shift2: 2, shift3: 3, shift4: 4, shift5: 5, shift6: 6,
            },
            {
                shift1: 1, shift2: 2, shift3: 3, shift4: 4, shift5: 5, shift6: 6,
            },
        ],
        []
    );

    const columns = React.useMemo(
        () => [

            {
                Header: 'Shift-1',
                accessor: 'shift1',
            },
            {
                Header: 'Shift-2',
                accessor: 'shift2',
            },
            {
                Header: 'Shift-3',
                accessor: 'shift3',
            },
            {
                Header: 'Shift-4',
                accessor: 'shift4',
            },
            {
                Header: 'Shift-5',
                accessor: 'shift5',
            },
        ],
        []
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({ columns, data });

    return (
        <div className="card shadow-sm h-100 my-0">
            <div className="card-body">
                <h5 className="card-title mb-4">Top 5 Working Vehicle Efficiency</h5>
                <div
                    className="table-responsive"
                    style={{ maxHeight: '300px', overflowY: 'auto', overflowX: 'auto' }}
                >
                    <table {...getTableProps()} className="table table-bordered table-striped table-sm mb-0">
                        <thead className="table-light">
                            {headerGroups.map(headerGroup => (
                                <tr {...headerGroup.getHeaderGroupProps()}>
                                    {headerGroup.headers.map(column => (
                                        <th {...column.getHeaderProps()}>{column.render('Header')}</th>
                                    ))}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {rows.map(row => {
                                prepareRow(row);
                                return (
                                    <tr {...row.getRowProps()}>
                                        {row.cells.map(cell => (
                                            <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                                        ))}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default TopFiveWorkingEffiency;